import { Component, Input } from '@angular/core';
import { magicPreviewDummyData } from '../../../classes/company';

@Component({
    selector: 'aira-pills',
    templateUrl: './aira-pills.component.html',
    styleUrl: './aira-pills.component.css',
    standalone: false
})
export class AiraPillsComponent {
  @Input() label;
  @Input() data;
  @Input() previewOnly: boolean = false;

  pillsToRender: any[] = [];
  leftoverCount: number = 0;

  ngOnInit() {
    this.handlePillsData();
  }

  handlePillsData() {
    if (this.previewOnly) {
      this.handlePreviewData();
    }
    if (!this.data?.length) return;

    if (this.data.length <= 5) {
      this.pillsToRender = this.data;
      return;
    }

    if (this.data.length > 5) {
      this.leftoverCount = this.data.length - 5;
      this.pillsToRender = this.data.slice(0, 5);
    }
  }

  showAllPills(): void {
    this.pillsToRender = this.data;
    this.leftoverCount = null;
  }

  handlePreviewData(): void {
    if (!this.previewOnly) return;
    // this.data = magicPreviewData.pillsProducts;
    const labelLowered = this.label.toLowerCase();
    if (labelLowered.includes('product')) {
      this.data = magicPreviewDummyData.pillsProducts;
    } else if (labelLowered.includes('factors')) {
      this.data = magicPreviewDummyData.pillsFactors;
    }
  }
}
